// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"017b8454","703":"a43ad199"}[chunkId] + ".chunk.js";
};